import React from "react";
import {
    BooleanInput, Create, Datagrid, DateField, Edit, Filter, List, SelectInput, SimpleForm, TextField, TextInput
} from "react-admin";

const GeoTagFilter = props => (
  <Filter {...props}>
    <TextInput label="Search by name" source="q" alwaysOn />
  </Filter>
);

export const GeoTagList = props => (
  <List {...props} filters={<GeoTagFilter />}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="status" />
    </Datagrid>
  </List>
);

export const GeoTagCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" />
    </SimpleForm>
  </Create>
);

export const GeoTagEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput label="Id" source="id" disabled />
      <TextInput source="name" />
      <TextInput source="slug" disabled />
      <SelectInput
        source="status"
        choices={[
          { id: "enabled", name: "enabled" },
          { id: "waitingforapproval", name: "waitingforapproval" },
          { id: "disabled", name: "disabled" }
        ]}
      />
      <BooleanInput
        source="hideFromSearch"
        label="Hide from the keyword search and related"
      />
      <SelectInput
        source="createdBy"
        choices={[
          { id: "obby", name: "obby" },
          { id: "teacher", name: "teacher" }
        ]}
      />
      <DateField label="Created Date" source="createdAt" locales="en-GB" />
      <DateField label="Updated Date" source="updatedAt" locales="en-GB" />
    </SimpleForm>
  </Edit>
);
